import getAddedProviders from '../utils/getAddedProviders';
import { FilePickerPreloadState } from '../store/schema/FilePickerPreloadState';
import { getFilePickerStore } from '../store/filePickerStore';
import { getProviderLoadState } from 'owa-fileprovider-store/lib/selectors/getProviderLoadState';
import { initializeFilePickerViewState } from '../utils/initializeFilePickerViewState';
import { setPreloadState } from '../actions/internalActions';
import {
    FileProviderViewState,
    lazyLoadProviders,
    ProviderLoadStateOption,
} from 'owa-fileprovider-store';

export default async function preloadFilePicker() {
    if (getFilePickerStore().viewState.preloadState !== FilePickerPreloadState.Loaded) {
        setPreloadState(FilePickerPreloadState.Loading);
        if (getProviderLoadState() === ProviderLoadStateOption.NotLoaded) {
            const loadProviders = await lazyLoadProviders.import();
            loadProviders(initializeViewState, onError);
        } else {
            initializeViewState(getAddedProviders());
        }
    }
}

async function initializeViewState(providers: FileProviderViewState[]) {
    await initializeFilePickerViewState(providers);
    setPreloadState(FilePickerPreloadState.Loaded);
}

function onError(error: Error) {
    setPreloadState(FilePickerPreloadState.NotLoaded);
}
